import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const StepZero = ({ctaPrimaryAction, ctaPrimaryText, ctaSecondaryAction, ctaSecondaryText, imageUrl, title}) => {
  return (
    <div className="mt-FormDealerRating-stepZero">
      <div className="mt-FormDealerRating-stepZeroContent">
        <TitleBasic as={titleBasicTags.h1} title={title} size={titleBasicSizes.s} />
        <div className="mt-FormDealerRating-stepZeroImageMobile">
          <AtomImage src={imageUrl} />
        </div>
        <div className="mt-FormDealerRating-stepZeroContentButtons">
          <AtomButton
            design={atomButtonDesigns.OUTLINE}
            color={atomButtonColors.PRIMARY}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.LARGE}
            onClick={ctaSecondaryAction}
            fullWidth
          >
            {ctaSecondaryText}
          </AtomButton>
          <AtomButton
            design={atomButtonDesigns.SOLID}
            color={atomButtonColors.PRIMARY}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.LARGE}
            onClick={ctaPrimaryAction}
            fullWidth
          >
            {ctaPrimaryText}
          </AtomButton>
        </div>
      </div>
      <div className="mt-FormDealerRating-stepZeroImage">
        <AtomImage src={imageUrl} />
      </div>
    </div>
  )
}

StepZero.propTypes = {
  ctaPrimaryAction: PropTypes.func,
  ctaPrimaryText: PropTypes.string,
  ctaSecondaryAction: PropTypes.func,
  ctaSecondaryText: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string
}

export default StepZero
